import { getAccountByProductType } from '../../multiLoanDashboard/accountsSelector';

export const LOADING_STATUS = 'loading';
export const ONGOING_STATUS = 'ongoing';

export const RLS_PRODUCT_TYPE = 'recovery_loan';

export const getDashboardStatus = (state) => {
    if (isOngoingStatus(state)) return ONGOING_STATUS;
};

const isOngoingStatus = (state) => {
    const account = getAccountByProductType(state, RLS_PRODUCT_TYPE);
    return account?.loan_status === 'ongoing';
};
